import { useHistory } from "react-router";
import HeaderBar from "../../../components/header/headerBar";
import SelectFeild from "../../../components/select/selectField";
import Input from "../../../components/textfield/input";
import {
  Textarea,
  TextBox,
} from "../../../components/textfield";
import { useEffect, useState } from "react";
import IconMdi from "@mdi/react";
import NumberFormat from "react-number-format";
import {
  mdiDelete,
  mdiChevronDownCircleOutline,
  mdiChevronUpCircleOutline,
} from "@mdi/js";
import MainButton from "../../../components/button/mainButton";
import EmptyModel from "../../../components/modal/emptyModal";
import { SearchField } from "../../../components/textfield";
import "../../../assets/styles/admin/usergroup.scss";
import Button from "../../../components/button/Button";

import {
  Table,
  Badge,
  Row,
  Col,
  DatePicker,
  Select,
  Space,
  Typography,
  Radio,
  Checkbox,
  InputNumber,
  Modal,
  Form,
  Spin,
  message,
} from "antd";
import { Icon } from "@iconify/react";
import { useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import styled from 'styled-components'
interface ParamsType {
  id: string;
}
const PrCreate = () => {
  const { id } = useParams<ParamsType>();
  const { Option } = Select;
  const { Text } = Typography;
  const { confirm } = Modal;
  const history = useHistory();
  const [data, setData] = useState<any>({
    code: "",
    dateOder: moment().format(),
    dateReceive: moment().format(),
    oderList: [],
    orderBy: {},
    vat : "Include"
  });
  const [isOpen1, setIsOpen1] = useState(false);
  const [productItem, setProductItem] = useState<any>([]);
  const [selectItem, setselectItem] = useState<any>({});
  const [unitList, setUnitList] = useState<any>([]);
  const [listTreatments, setlistTreatments] = useState<any>([]);
  const [supplier, setSupplier] = useState<any>([]);
  const [payment, setPayment] = useState<any>([]);

  const ChangRender = styled.div``
  const ReScalerCol = styled.div`
  padding-left: 1.7rem;
  }`

  const columns = [
    {
      key: "code",
      title: <>รหัส<br/>Code</>,
      dataIndex: "code",
      align: "center" as "center",
      width: "100px",
    },
    {
      key: "name",
      title: <>ชื่อ<br/>Name</>,
      dataIndex: "name",
      align: "center" as "center",
    },
    {
      key: "quantiyUnit",
      title: <>จำนวน/หน่วย<br/>Quantity/Unit</>,
      dataIndex: "quantiyUnit",
      align: "center" as "center",

    },
    {
      key: "quantiySubUnit",
      title: <>หน่วยย่อย<br/>Sub Unit</>,
      dataIndex: "quantiySubUnit",
      align: "center" as "center",
    },
    {
      key: "quantiySubUnit2",
      title: <>หน่วยย่อย2<br/>Sub Unit 2</>,
      dataIndex: "quantiySubUnit2",
      align: "center" as "center",
    },
    {
      key: "total_price_per_unit",
      title: <>ราคา/หน่วย<br/>Price/Unit</>,
      dataIndex: "total_price_per_unit",
      align: "center" as "center"
    },

    {
      key: "total_price_per_unit",
      title: <>รวม<br/>Total</>,
      dataIndex: "total_price_per_unit",
      align: "center" as "center",
      render: (text: any, record: any, index: any) => {
        return record.quantiyUnit * text
      },
    },
    {
      key: "",
      title: "",
      dataIndex: "",
      align: "center" as "center",
      render: (text: any, record: any, index: any) => {
        return (
          <Icon
            onClick={() => {
              removeItem(index)
            }}
            icon="codicon:trash"
            color="#FF6760"
            width="24"
            height="24"
          />
        )
      },
    },
  ];
  const columnsItem = [
    {
      key: "productCode",
      title: <>รหัส<br/>Code</>,
      dataIndex: "productCode",
      align: "center" as "center",
      width: "150px",
    },
    {
      key: "name",
      title: <>ชื่อ<br/>Name</>,
      dataIndex: "name",
      width: "200px",
    },
    {
      key: "unit",
      title: <>หน่วย<br/>Unit</>,
      dataIndex: "unit",
      align: "center" as "center",
      width: "100px",
      render: (text: any, record: any, index: any) => {
        return text.name
      },
    },
    {
      key: "balanceAmount",
      title: <>จำนวนคงเหลือ<br/>Balance Amount</>,
      dataIndex: "balanceAmount",
      align: "center" as "center",
      width: "80px",
      render: (text: any, record: any, index: any) => {
        return text || 0
      },
    },
    {
      title: <>เลือก<br/>Select</>,
      key: "Code",
      align: "center" as "center",
      dataIndex: "code",
      width: "80px",
      render: (text: any, record: any, index: any) => {
        return (
          <Icon
            onClick={() => {
              setIsOpen1(false);
              setselectItem(record);
            }}
            icon="akar-icons:circle-plus-fill"
            color="#4d7e7f"
            width="24"
            height="24"
          />
        );
      },
    },
  ];
  function onClose() {
    setIsOpen1(false);
  }


  useEffect(() => {
    getProduct();
    getData();
    getUnits();
    getSupplier();
    getPayment()
  }, []);

  useEffect(() => {

  }, [listTreatments]);

  const addItem = () => {
    data.oderList.push(selectItem);
    setData(data);
    setselectItem({})
  }
  const removeItem = (index: number) => {
    let oderList = data.oderList;
    oderList.splice(index, 1);
    setData({
      ...data,
      oderList
    });
  }

  const getProduct = () => {
    axios.get(`/stock-products/map`).then((res) => {
      setProductItem(res?.data?.data)
    });
  };
  const getData = () => {
    axios.get(`/stock-products/pr/${id}`).then((res) => {
      setData(res?.data)
    }).catch((err: any) => {
      message.error(err.response.data.message);
    });
  };
  const getUnits = () => {
    axios.get(`/stock-product-units`).then((res) => {
      setUnitList(res?.data?.data.map((item: any, index: number) => {
        return {
          value: item?._id,
          name: item?.name
        }
      }))
    });
  };
  const getSupplier = () => {
    axios.get(`/supplier`).then((res) => {
      setSupplier(res?.data?.data.map((item: any, index: number) => {
        return {
          value: item?._id,
          label: item?.supplierName
        }
      }))
    });
  };
  const getPayment = () => {
    axios.get(`/payments`).then((res) => {
      const { data } = res;
      setPayment(data.filter((i: any) => i.format === "payment").map((k: any) => ({
        value: k?._id,
        label: k?.name
      })));
    });
  }
  const updatePr = () => {
    axios.patch(`/stock-products/pr/${id}`, data).then((res : any) => {
      history.push('/setting/inventory/pr')
    }).catch((err: any) => {
      message.error(err.response.data.message);
    });
  }
  const NumberFormat = (number: number) => {
    return new Intl.NumberFormat().format(number)
  }

  const vat = data.oderList.reduce((total: number, item: any) => {
    return total + (item.total_price_per_unit * item.quantiyUnit)
  }, 0) * 7 / 107;

  const discount_vat = data.oderList.reduce((total: number, item: any) => {
    return total + (item.total_price_per_unit * item.quantiyUnit)
  }, 0) * 100 / 107;
  return (
    <>
      <HeaderBar title="PR Order/Create PR Order" btnBack={true} />
      <div style={{ padding: "10px 40px" }}>
        <EmptyModel show={isOpen1} onClose={onClose} width="80%" setStyle={{ height: "auto" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <h4>เลือกรายการ/Select Item </h4>

            <div className="row justify-center mt-2">
              <SearchField
                placeholder="Search for  Name"
                color="#fff"
              />
            </div>
            <div className="row justify-start mt-2">
              <div className="card ex3">
                <div
                  className="card-body"
                  style={{
                    overflow: "auto",
                    height: "300px",
                  }}
                >
                  <Table
                    columns={columnsItem}
                    dataSource={productItem}
                    bordered
                    scroll={{ x: "max-content" }}
                    rowKey="_id"
                  />
                </div>
              </div>
            </div>
          </div>
        </EmptyModel>
        <div className="create-page">
          <div className="title-header">
            <h3>สร้างใบขอซื้อ/Create PR Order</h3>
          </div>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={4} md={8} lg={7}>
              <TextBox
                title="เลขที่ใบขอซื้อ/PR No."
                className="p-0"
                value={data.code}
              />
            </Col>
            <Col xs={24} sm={4} md={8} lg={16}>
              <ReScalerCol>
                <div className="input" style={{ height: "auto" }}>
                  <div className="title-input">ผู้ผลิต/Supplier</div>
                </div>
                <ChangRender>
                  <Select
                    className="antd-Selected col-12"
                    showSearch
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                    defaultValue={data.supplier}
                    onChange={(val: string) => setData({ ...data, supplier: val })}
                    options={supplier}
                  />
                </ChangRender>
              </ReScalerCol>
            </Col>
          </Row>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={4} md={8} lg={7}>
              <div className="heading">
                <p>วันที่สั่งซื้อ/Date Order</p>
              </div>
              <Form.Item
                name="startDate"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <ChangRender>
                  <DatePicker
                    placeholder="mm/dd/yyyy"
                    format="DD-MM-YYYY"
                    style={{
                      height: "auto",
                      width: "100%",
                      border: "none",
                      borderRadius: "0px",
                      borderBottom: "2px solid #d9d9d9",
                    }}
                    defaultValue={moment(data?.dateOder)}
                    onChange={(e: any) => {
                      setData({ ...data, dateOder: e.format() })
                    }}
                  /></ChangRender>
              </Form.Item>
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>
              <div className="heading">
                <p>วันที่รับเข้า/Receive</p>
              </div>
              <Form.Item
                name="startDate"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <ChangRender>
                  <DatePicker
                    placeholder="mm/dd/yyyy"
                    format="DD-MM-YYYY"
                    style={{
                      height: "auto",
                      width: "100%",
                      border: "none",
                      borderRadius: "0px",
                      borderBottom: "2px solid #d9d9d9",
                    }}
                    defaultValue={moment(data?.dateReceive)}
                    onChange={(e: any) => {
                      setData({ ...data, dateReceive: e.format() })
                    }}
                  />
                </ChangRender>
              </Form.Item>
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>
              <TextBox
                title="สั่งโดย/Order by"
                className="p-0"
                value={data?.orderBy?.displayName}
              />
            </Col>
          </Row>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={4} md={8} lg={7}>
              <div className="input col-12" style={{ height: "auto" }}>
                <div className="title-input">ภาษี/Vat</div>
              </div>
              <ChangRender>              
                <Select
                className="antd-Selected col-12"
                showSearch
                suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                defaultValue={data.vat}
                onChange={(val: string) => setData({ ...data, vat: val })}
                options={[{
                  value: "Include",
                  label: "Include"
                },
                {
                  value: "Exclude",
                  label: "Exclude"
                }]}
              />
              </ChangRender>

            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>
              <div className="input col-12" style={{ height: "auto" }}>
                <div className="title-input">ชำระเงิน/Credit</div>
              </div>
              <ChangRender>
                <Select
                  className="antd-Selected col-12"
                  showSearch
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  defaultValue={data.credit}
                  onChange={(val: string) => setData({ ...data, credit: val })}
                  options={payment}
                />
              </ChangRender>
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>

            </Col>
          </Row>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={24} md={24} lg={24}>
              <Textarea
                title="รายละเอียด/Details"
                placeholder=""
                value={data?.details}
                onChange={(e:any) => setData({...data, details : e.target.value})}
              />
            </Col>
          </Row>
        </div>

        <div className="create-page mt-4">
          <div className="title-header" style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignContent: 'center',
            alignItems: 'center'
          }}>
            <h3>สร้างรายการ/Create List</h3>
            <Button
              title="เลือกรายการ/ADD"
              width={175}
              onClick={() => setIsOpen1(true)}
            >
            </Button>
          </div>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={4} md={8} lg={7}>
              <TextBox
                title="รหัส/Code"
                className="p-0"
                value={selectItem?.code}
              />
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>
              <TextBox
                title="ชื่อ/Name"
                className="p-0"
                value={selectItem?.name}
              />
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}></Col>
          </Row>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={4} md={8} lg={7}>
              <Row
                justify="space-between"
                style={{
                  marginTop: "10px",
                }}
              >
                <Col xs={24} sm={12} md={12} lg={11}>
                  <ChangRender>
                    <div
                      style={{
                        color: "#5BAEA9",
                        marginBottom: 5,
                        fontSize: 14,
                        fontWeight: 500,
                      }}
                    >
                      หน่วยใหญ่/Unit
                    </div>
                    <Form.Item
                      name="Category"
                    >
                      <Select
                        className="antd-Selected"
                        showSearch
                        suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                        defaultValue={selectItem?.unit}
                        onChange={(val: string) => setselectItem({ ...selectItem, unit: val })}
                      >
                        <Option value=""> </Option>
                        {unitList?.map((province: any) => (
                          <Option key={province} value={province?.value}>{province?.name}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </ChangRender>
                </Col>
                <Col xs={24} sm={12} md={12} lg={11}>
                  <Input
                    title="จำนวน/Quantiy"
                    type="number"
                    value={selectItem?.quantiyUnit || ''}
                    onChange={(e: any) => setselectItem({ ...selectItem, quantiyUnit: e.target.value })}
                  />
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>
              <Row
                justify="space-between"
                style={{
                  marginTop: "10px",
                }}
              >
                <Col xs={24} sm={12} md={12} lg={11}>
                  <ChangRender>
                    <div
                      style={{
                        color: "#5BAEA9",
                        marginBottom: 5,
                        fontSize: 14,
                        fontWeight: 500,
                      }}
                    >
                      หน่วยย่อย/Sub Unit
                    </div>
                    <Form.Item
                      name="Category"
                    >

                      <Select
                        className="antd-Selected"
                        showSearch
                        suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                        defaultValue={selectItem?.subUnit}
                        onChange={(val: string) => setselectItem({ ...selectItem, subUnit: val })}
                      >
                        <Option value=""> </Option>
                        {unitList?.map((province: any, index: number) => (
                          <Option key={province} value={province?.value}>{province?.name}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </ChangRender>
                </Col>
                <Col xs={24} sm={12} md={12} lg={11}>
                  <Input
                    title="จำนวน/Quantiy"
                    type="number"
                    value={selectItem?.quantiySubUnit || ''}
                    onChange={(e: any) => setselectItem({ ...selectItem, quantiySubUnit: e.target.value })}
                  />
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>
              <Row
                justify="space-between"
                style={{
                  marginTop: "10px",
                }}
              >
                <Col xs={24} sm={12} md={12} lg={11}>
                  <ChangRender>
                    <div
                      style={{
                        color: "#5BAEA9",
                        marginBottom: 5,
                        fontSize: 14,
                        fontWeight: 500,
                      }}
                    >
                      หน่วยย่อย2/Sub Unit2
                    </div>
                    <Form.Item
                      name="Category"
                    >

                      <Select
                        className="antd-Selected"
                        showSearch
                        suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                        defaultValue={selectItem?.subUnit2}
                        onChange={(val: string) => setselectItem({ ...selectItem, subUnit2: val })}
                      >
                        <Option value=""> </Option>
                        {unitList?.map((province: any) => (
                          <Option key={province} value={province?.value}>{province?.name}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </ChangRender>
                </Col>
                <Col xs={24} sm={12} md={12} lg={11}>
                  <Input
                    title="จำนวน/Quantiy"
                    type="number"
                    value={selectItem?.quantiySubUnit2 || ''}
                    onChange={(e: any) => setselectItem({ ...selectItem, quantiySubUnit2: e.target.value })}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={4} md={8} lg={7}>
              
              <Input
                title="ราคาต่อหน่วยใหญ่/Unit Price"
                type="text"
                value={selectItem?.total_price_per_unit || ''}
                onChange={(e: any) => setselectItem({ ...selectItem, total_price_per_unit: e.target.value })}
              />
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>

            </Col>
            <Col xs={24} sm={4} md={8} lg={7} style={{
              display: 'grid',
              justifyItems: 'end'
            }}>
              <Button
              
                title="บันทึกรายการ/Save"
                width={175}
                onClick={() => addItem()}
              >
              </Button>
            </Col>
          </Row>
        </div>


        <div className="create-page mt-4">
          <div className="title-header" style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignContent: 'center',
            alignItems: 'center'
          }}>
            <h3>รายการสั่งซื้อ/Order List</h3>
          </div>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={24} md={24} lg={24}>
              <ChangRender>
                {
                  data.oderList &&
                  <Table
                    columns={columns}
                    dataSource={data.oderList}
                    bordered
                    scroll={{ x: "max-content" }}
                    rowKey="_id"
                  />
                }
              </ChangRender>
            </Col>
          </Row>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={12} md={12} lg={12}>

            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Row className="mt-2">
                <Col xs={24} sm={16} md={16} lg={16} style={{
                  textAlign: 'right',
                  color: '#5baea9',
                  fontWeight: 'bold'
                }}>รวม/Total</Col>
                <Col xs={24} sm={8} md={8} lg={8} style={{
                  textAlign: 'right',
                  borderBottom: '1px solid #d3d8dd'
                }}>
                  {
                    NumberFormat(data.oderList.reduce((total: number, item: any) => {
                      return total + (item.total_price_per_unit * item.quantiyUnit)
                    }, 0))
                  }
                </Col>
              </Row>
              <Row className="mt-2">
                <Col xs={24} sm={16} md={16} lg={16} style={{
                  textAlign: 'right',
                  color: '#5baea9',
                  fontWeight: 'bold'
                }}>ภาษี/Vat</Col>
                <Col xs={24} sm={8} md={8} lg={8} style={{
                  textAlign: 'right',
                  borderBottom: '1px solid #d3d8dd'
                }}>
                  {NumberFormat(vat)}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col xs={24} sm={16} md={16} lg={16} style={{
                  textAlign: 'right',
                  color: '#5baea9',
                  fontWeight: 'bold'
                }}>ราคารวม/Total Price</Col>
                <Col xs={24} sm={8} md={8} lg={8} style={{
                  textAlign: 'right',
                  borderBottom: '1px solid #d3d8dd'
                }}>
                  {
                    data?.vat === "Include" ?
                    NumberFormat(data.oderList.reduce((total: number, item: any) => {
                      return total + (item.total_price_per_unit * item.quantiyUnit)
                    }, 0))
                    :
                    NumberFormat(data.oderList.reduce((total: number, item: any) => {
                      return total + (item.total_price_per_unit * item.quantiyUnit)
                    }, 0) + vat)
                  }
                </Col>
              </Row>
            </Col>
          </Row>
          <div className="justify-center mt-20">
            <MainButton className="mg-10" background="#E76464" title="ยกเลิก/Cancel" onClick={() => history.goBack()} />
            <MainButton
              className="mg-10"
              title="บันทึกข้อมูล/Submit"
              onClick={() => {
                updatePr()
              }}
            />
          </div>
        </div>
      </div>
    </>
  );

};
export default PrCreate;
